<template>
	<div class="container__importshape">
		<GmapMap
			ref="mapRef"
			map-type-id="satellite"
			class="container__googlemaps__position"
			:center="{ lat: -17.390269, lng: -40.538804 }"
			:zoom="16"
		>
			<!-- 
        componente que recebe o shape de fazenda
       -->
			<PolygonShape
				:editable="false"
				:options="shapeOptionsFzda"
				:coordinates="getGeoJsonFzda.coordinates"
				:type="getGeoJsonFzda.type"
			/>

			<!-- 
        componente que recebe o shape de talhão
       -->
			<PolygonShape
				v-for="(coordinateAndType, index) in getGeoJsonTlho.features"
				:key="`T-${index}`"
				:editable="false"
				:options="shapeOptionsTlho"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
			/>

			<!-- 
        componente que recebe o shape de plantio
       -->
			<PolygonShape
				v-for="(coordinateAndType, index) in getGeoJsonPtio.features"
				:key="`P-${index}`"
				:editable="false"
				:options="shapeOptionsPtio"
				:coordinates="coordinateAndType.coordinates"
				:type="coordinateAndType.type"
			/>

			<div v-if="togglePlantio">
				<PlantioMarker
					v-for="(plantioMarker, index) in plantioMarkers"
					:key="`${index}-plantioMarker`"
					:plantio-marker="plantioMarker"
					@showEstratoContinuos="showEstratoContinuos($event)"
				/>
			</div>
		</GmapMap>

		<i
			class="fas fa-times container__importshape__close"
			@click="close"
		/>
		<div
			v-show="!showForm"
			class="BackArrow"
		>
			<Button
				style="padding-right: 20px !important"
				icon="fas fa-bars"
				outlined
				@click="changeFormAndCloseAllActions2"
			/>
		</div>
		<div
			v-show="showImportShape"
			class="container__importshape__shapefiles__body"
		>
			<div
				v-show="isImportShp"
				class="container__importshape__shapefiles__files"
			>
				<ShapeFileUpload
					ref="ref__shapefileupload"
					:fzda-id="fzdaId"
					@showMapTlho="showMapTlho"
					@showMapPtio="showMapPtio"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import * as turf from '@turf/turf'

import SHAPE_OPTIONS_FZDA from '../../../../../constants/ShapeOptions/ShapeFzda'
import SHAPE_OPTIONS_TLHO from '../../../../../constants/ShapeOptions/ShapeTlho'
import { SHAPE_OPTIONS_PLANTIO_POLIOGONO_IMPORTACAO } from '../../../../../constants/ShapeOptions/ShapePtio'

import PolygonShape from '../../../../../components/Map/PolygonShape'
import PlantioMarker from '../../../../../components/PlantioMarker/PantioMarker'
import ShapeFileUpload from './ShapeFileUpload/ShapeFileUpload'
import Button from '../../../../../components/Button/Button'
import { mapGetters, mapMutations } from 'vuex'

export default {
	components: {
		PlantioMarker,
		PolygonShape,
		ShapeFileUpload,
		Button,
	},

	computed: {
		...mapGetters('moduleImportShape', [
			'plantioMarkers',
			'getGeoJsonFzda',
			'getGeoJsonTlho',
			'getGeoJsonPtio',
		]),
	},

	data() {
		return {
			showInfoPlantio: false,
			tabs: null,
			tabs2: null,
			tabs3: null,

			/**
			 * Dados para verificar o que deve ser exibido na janela da importacao
			 * ou os FileUpload para enviar os arquivos ou o mapeamento dos dados
			 */
			isImportShp: true,
			isMappedTlho: false,
			isMappedPtio: false,
			showForm: true,
			/**
			 * Lista com o que deve ser mapeado na importacao e as colunas que
			 * estão no shape que está sendo importado
			 */
			baseMapData: [],
			columnsShp: [],
			/**
			 * Estilizacao dos Shapes
			 */
			shapeOptionsFzda: SHAPE_OPTIONS_FZDA,
			shapeOptionsTlho: SHAPE_OPTIONS_TLHO,
			shapeOptionsPtio: SHAPE_OPTIONS_PLANTIO_POLIOGONO_IMPORTACAO,
			/**
			 * Exibe ou não o card para importar os shapes
			 */
			showImportShape: false,
			/**
			 * Exibe ou não o card para mapear colunas do shape com o sistema
			 */
			showMapData: false,
		}
	},
	methods: {
		voltar() {
			console.log('🚀 ~ file: ImportShape.vue ~ line 463 ~ voltar ~ voltar', this.getGeoJsonFzda)
			// this.fechar = false;
		},
		...mapMutations('moduleImportShape', [
			'resetImportShapeState',
			'setGeoJsonFzda',
			'setGeoJsonTlho',
			'setGeoJsonPtio',
			'setFzdaHasFileInDB',
			'setTlhoHasFileInDB',
			'setPtioHasFileInDB',
			'setBounds',
		]),
		changeFormAndCloseAllActions() {
			this.showForm = false
		},
		changeFormAndCloseAllActions2() {
			this.showForm = true
		},
		/**
		 * Exibe os campos para importar o shape
		 */
		showImportShapeFile() {
			this.isImportShp = true
			if (this.isMappedTlho) {
				this.$refs.ref__shapefileupload.$refs.ref_component_fileupload_tlho.$data.hasFileInFrontEnd = false
				this.isMappedTlho = false
			} else if (this.isMappedPtio) {
				this.$refs.ref__shapefileupload.$refs.ref_component_fileupload_ptio.$data.hasFileInFrontEnd = false
				this.isMappedPtio = false
			}
		},

		/**
		 * Exibe os campos para mapeamento de dados de plantio
		 */
		showMapPtio() {
			this.isImportShp = false
			this.isMappedTlho = false
			this.isMappedPtio = true
		},

		/**
		 * Exibe os campos para mapeamento de dados de talhao
		 */
		showMapTlho() {
			this.isImportShp = false
			this.isMappedPtio = false
			this.isMappedTlho = true
		},
	},
	props: {
		togglePlantio: {
			type: Boolean,
			default: false,
		},
		/**
		 * Funcao para quando clicar em fechar
		 */
		close: Function,
		/**
		 * Id da fazenda que terá o shape importado
		 */
		fzdaId: String,
	},
	watch: {
		'$store.state.moduleImportShape.bounds': {
			immediate: true,
			deep: true,
			async handler(value) {
				if (Object.keys(value).length > 0 && this.$refs.mapRef) {
					this.$refs.mapRef.$mapPromise.then((map) => {
						setTimeout(function () {
							map.fitBounds(value, 0)
						}, 500)
					})
				}
			},
		},
	},
	/**
	 * Reseta o estado que gerencia a importacao dos shapes
	 * e busca os shapes que devem ser plotados
	 */
	created() {
		console.log(this.$refs)
		console.log(Object.keys(this.getGeoJsonFzda).length === 0)
		/*this.resetImportShapeState();

    securityApi.get(`/AllPolygon/${this.fzdaId}`).then((response) => {
      const { [0]: model } = response.data.model;

      // Seta o poligono de Fazenda
      if (model.fzda_md_poligono) {
        this.setFzdaHasFileInDB(true);
        this.setGeoJsonFzda({
          coordinates: model.fzda_md_poligono.coordinates,
          type: model.fzda_md_poligono.type,
        });
      }

      // Seta os poligonos de talhão
      if (model.tbg_tlho_talhaos.length > 0) {
        this.setTlhoHasFileInDB(true);
        this.setGeoJsonTlho(
          model.tbg_tlho_talhaos.map((m) => {
            return {
              type: m.tlho_md_poligono.type,
              coordinates: m.tlho_md_poligono.coordinates,
            };
          })
        );
      }

      let tlhos = [];
      let ptios = [];

      if (model.fzda_md_poligono) {
        this.setFzdaHasFileInDB(true);
        this.setGeoJsonFzda({
          coordinates: model.fzda_md_poligono.coordinates,
          type: model.fzda_md_poligono.type,
        });

        model.tbg_tlho_talhaos.forEach((f) => {
          this.setTlhoHasFileInDB(true);
          tlhos.push(f.tlho_md_poligono);
          if (f.tbg_ptio_plantios.length > 0) {
            this.setPtioHasFileInDB(true);
            ptios.push(f.tbg_ptio_plantios[0].ptio_md_poligono);
          }
        });
      }

      this.setGeoJsonTlho(tlhos);
      this.setGeoJsonPtio(ptios);
    });*/
	},
	mounted() {
		// Caso possua poligono de fazenda, seta o zoom no mapa
		if (this.getGeoJsonFzda.coordinates) {
			const bbox = turf.bbox({
				coordinates: this.getGeoJsonFzda.coordinates,
				type: this.getGeoJsonFzda.type,
				properties: this.getGeoJsonFzda.properties,
			})
			this.setBounds(bbox)
		}
	},
}
</script>

<style>
.container__importshape {
	position: fixed;
	left: 0;
	top: var(--menu-height);
	height: 100%;
	width: 100vw;
	z-index: 200;
	font-size: 0.75rem;
}
.container__importshape__close {
	position: absolute;
	color: white;
	font-size: 1rem;
	top: 0;
	right: 0rem;
	padding: 1.5rem;
	cursor: pointer;
}
.BackArrow {
	width: 2.5rem;
	height: 3rem;
	position: absolute;
	top: 5rem;
	right: 0%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.footer {
	position: fixed;
	margin: 10px 0;
	bottom: 0;
}

.container__importshape__shapefiles {
	width: 20rem;
	position: absolute;
	bottom: 3rem;
	left: 50%;
	transform: translateX(-50%);
	background-color: white;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.container__importshape__shapefiles__header {
	background-color: rgb(var(--color-primary));
	padding: 0.5rem 1rem;
	font-size: 0.8rem;
	display: flex;
	align-items: center;
	color: rgb(var(--color-default));
	cursor: pointer;
}

.container__importshape__shapefiles__header i {
	margin-right: 1rem;
	font-size: 1rem;
}

.container__importshape__shapefiles__header__title {
	display: flex;
	flex-direction: column;
	line-height: 1.1rem;
	cursor: pointer;
}

.container__importshape__shapefiles__header__title :first-child {
	font-weight: 600;
	font-size: 0.9rem;
	cursor: pointer;
}

.container__importshape__shapefiles__header__title :last-child {
	color: white;
	font-weight: 300;
	cursor: pointer;
}

.container__importshape__shapefiles__files {
	height: auto;
	display: flex;
	justify-content: space-around;
	padding: 1rem 1rem 0 1rem;
}

.container__importshape__shapefiles__mapdata {
	width: 100%;
}

.Download {
	display: flex;
	justify-content: space-between;
}

.container__googlemaps__position {
	height: 100%;
	position: relative;
}
.container__importshape .gm-fullscreen-control {
	margin-top: 10% !important;
}
.container__importshape .gm-control-active,
.container__importshape .gmnoprint {
	left: 0%;
	top: 145px;
	pointer-events: none;
}
.container__importshape .gm-svpc {
	-webkit-transform: scaleX(-1);
	transform: scaleX(-1);
}

@media screen and (min-width: 576px) {
	.container__importshape__shapefiles {
		left: 1rem;
		transform: translateY(0);
	}

	.container__importshape .gm-control-active,
	.container__importshape .gmnoprint {
		display: block;
		height: 5%;
	}

	.container__importshape .gm-fullscreen-control {
		right: 3rem !important;
	}
}

@media screen and (min-width: 992px) {
	.container__importshape {
		width: 100vw;
		z-index: 110;
	}

	.container__importshape__close {
		display: none;
	}

	.container__importshape .gm-fullscreen-control {
		right: 1rem !important;
	}
}
.demo {
	font-family: sans-serif;
	border: 1px solid #eee;
	border-radius: 2px;
	padding: 20px 30px;
	margin-top: 1em;
	margin-bottom: 40px;
	user-select: none;
	overflow-x: auto;
}

.tab-button {
	padding: 6px 10px;
	border-top-left-radius: 3px;
	border-top-right-radius: 3px;
	border: 1px solid #ccc;
	cursor: pointer;
	background: #f0f0f0;
	margin-bottom: -1px;
	margin-right: -1px;
}
.tab-button:hover {
	background: #e0e0e0;
}
.tab-button.active {
	background: #e0e0e0;
}
.demo-tab {
	border: 1px solid #ccc;
	padding: 10px;
}
</style>
